/* @noflow TODO make dangerouslyTrackTapFromComponentInstance pass types correctly */
import * as React from 'react';
import PropTypes from 'prop-types';

import EventTracking, {
  getEventScreenName,
  getEventElementName,
  getEventContextName,
  getEventProperties,
} from 'lib/EventTracking';
import createChainedFunction from 'utils/createChainedFunction';

// Dangerous because this should only be used if the component has the correct context types.
export const dangerouslyTrackTapFromComponentInstance = (component: React.Component<*, *>) => {
  const elementName = getEventElementName(component.props);
  const screenName = getEventScreenName(component.props, component.context.router);
  if (elementName && screenName) {
    EventTracking.tap(
      screenName,
      elementName,
      getEventContextName(component.props, component.context),
      getEventProperties(component.props.eventProperties, component.context)
    );
  }

  if (component.props.eventKey) {
    EventTracking.trackKey(component.props.eventKey, component.props.eventProperties);
  }
};

type Props = {
  eventKey?: ?string,
  eventElementName?: ?string,
  eventScreenName?: ?string,
  eventProperties?: ?Object,
  children: React$Element<*> | React$Element<*>[],
};

class ClickEventTrigger extends React.Component<Props> {
  // TODO do we have to set contextTypes here for the child, or will cloning get that?
  static contextTypes = {
    eventScreenName: PropTypes.string,
    eventProperties: PropTypes.object,
    eventContextName: PropTypes.string,
    router: PropTypes.object,
  };
  render() {
    const child: React$Element<*> = React.Children.only(this.props.children);
    return React.cloneElement(child, {
      ...child.props,
      onClick: createChainedFunction(
        () => dangerouslyTrackTapFromComponentInstance(this),
        child.props.onClick
      ),
    });
  }
}

export default ClickEventTrigger;
